import React from "react";
import {useNavigate} from "react-router-dom";
import {selectUserInfo} from "../../../features/account/accountSlice";
import {useAppSelector} from "../../../hooks";
import {MY_RECORDS_ROUTE} from "../../../routes";
import {DATA_LIST_PAGE_SIZE} from "../../../settings";
import {RecordsList} from "../../Widgets/RecordsList/RecordsList";
import {Breadcrumbs} from "../../Widgets/Breadcrumbs/Breadcrumbs";
import {MenuItem} from "@szhsin/react-menu";
import {useTranslation} from "react-i18next";
import {AccessType} from "../../../models/AccessType";
import {StudyType} from "../../Widgets/StudyIcon/StudyIcon";
import {ListItemContextMenu, openInNewTab, useListContextMenu} from "../../Widgets/ListItemContextMenu/ListItemContextMenu";

function MyRecords() {
    const {t} = useTranslation();
    const history = useNavigate();
    const userInfo = useAppSelector(selectUserInfo);
    const {menuProps, anchorPoint, targetId, onContextMenu, close} = useListContextMenu();
    const recordPath = (id: string) => `${MY_RECORDS_ROUTE}/${id}`;
    const recordClickHandler = (id: string) => {
        history(recordPath(id));
    };
    const studyClickHandler = (id: string, type: StudyType) => {
        switch (type) {
            case StudyType.State:
                recordClickHandler(id);
                break;
            case StudyType.Ecg:
                history(`${MY_RECORDS_ROUTE}/${id}/ecg`)
                break;
            case StudyType.Stethoscope:
                history(`${MY_RECORDS_ROUTE}/${id}/stethoscope`)
                break;
            case StudyType.Spiro:
                history(`${MY_RECORDS_ROUTE}/${id}/spiro`)
                break;
            case StudyType.LtEcg:
                recordClickHandler(id);
                break;
        }
    };
    const openClickHandler = () => {
        if (targetId) {
            recordClickHandler(targetId);
        }
    };
    const openInNewTabClickHandler = () => {
        if (targetId) {
            openInNewTab(recordPath(targetId));
        }
    };
    const shareClickHandler = () => {
        if (targetId) {
            history(`${MY_RECORDS_ROUTE}/${targetId}/share`);
        }
    };
    return (
        <div>
            <Breadcrumbs/>
            <RecordsList tag="list_my_records" pageSize={DATA_LIST_PAGE_SIZE} userId={userInfo?.id ?? null} accessType={AccessType.Owner}
                         patientId={null}
                         recordClickHandler={recordClickHandler} contextMenuHandler={onContextMenu} studyClickHandler={studyClickHandler}
                         studyRecordPath={recordPath}/>
            <ListItemContextMenu menuProps={menuProps} anchorPoint={anchorPoint}
                                 onClose={close} onOpen={openClickHandler} onOpenInNewTab={openInNewTabClickHandler}>
                <MenuItem onClick={shareClickHandler}>{t("access_control")}</MenuItem>
            </ListItemContextMenu>
        </div>
    );
}

export default MyRecords;
